import SeoHead from "@/components/feature/SeoHead";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import CategoriesOverview from "./components/CategoriesOverview";
import HotArticles from "./components/HotArticles";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "禁漫天堂",
    url: "https://jmtt.example.com",
    description: "禁漫天堂是广受用户关注的漫画平台，提供最新访问入口、注册登录教程、内容分类导览及常见问题解答。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://jmtt.example.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <SeoHead
        title="禁漫天堂 – 官方入口与完整使用指南 | 最新访问入口、注册教程、内容分类"
        description="禁漫天堂是广受用户关注的漫画平台，本页提供禁漫天堂最新访问入口、注册登录教程、内容分类导览及常见问题解答，帮助用户快速、安全地找到并使用禁漫天堂的全部功能。"
        keywords="禁漫天堂,禁漫天堂入口,禁漫天堂最新地址,禁漫天堂注册登录,禁漫天堂镜像站,禁漫天堂使用教程,禁漫天堂内容分类"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <FeaturesSection />
      <CategoriesOverview />
      <HotArticles />
      <FaqSection />
      <CtaSection />
    </>
  );
}